import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  border-radius: 22px;
  box-shadow: var(--drop-shadow-15-25);

  button {
    margin: 0px !important;
    border-radius: 10px !important;
    height: 41px !important;
    white-space: nowrap;
    box-sizing: border-box;
  }

  &.dark {
    background-color: var(--primary-cta);
    color: white;

    button {
      background-color: white !important;
      color: var(--primary-cta) !important;

      &.disabled {
        background-color: rgba(255, 255, 255, 0.8) !important;
      }
    }
  }

  &.light {
    color: var(--grey-0);
    background-color: var(--menu-color);
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    margin-bottom: 0;

    .title {
      font-size: 21px;
      font-weight: 500;
    }

    .subtitle {
      font-size: 17px;
      line-height: 1.3;
      font-weight: 500;
      opacity: 0.7;
    }
  }

  .actions {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    gap: 10px;

    .selector {
      width: 130px;
    }

    .submit-button-container#chapter-creator-submit-button-container-bottom,
    .submit-button-container#chapter-creator-submit-button-container-top {
      position: relative;
      background: white;
      border-radius: 10px;

      button.submit {
        cursor: pointer;
        &:hover {
          background-color: var(--primary-cta-transparent) !important;
        }

        &:active {
          background-color: var(--primary-cta-transparent-15) !important;
        }

        &.disabled,
        &:disabled {
          opacity: 1 !important;

          background-color: var(--grey-2) !important;

          &:hover {
            background-color: var(--grey-2) !important;
          }
        }
      }
    }

    .submit-button-container#chapter-creator-submit-button-container-top {
      button.submit {
        &:hover {
          background-color: var(--primary-cta-hover) !important;
        }

        &:active {
          background-color: var(--primary-cta-active) !important;
        }
      }
    }
  }
`;
